<template>
  <div class="selectrow">
    <label>Civilité</label>
    <div class="row form-group2">
      <el-select
        :disabled="disabled"
        :value="value"
        class="col-md-12 select-info"
        size="large"
        @input="$emit('input', $event)"
      >
        <el-option
          v-for="option in selects.titles"
          :value="option.value"
          :label="option.label"
          :key="option.label"
          class="select-info"
        />
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectTitle',
  props: ['value', 'disabled'],
  data() {
    return {
      editingDisabled: false,
      selects: {
        simple: '',
        titles: [
          {
            key: 'key',
            value: 'value',
          },
        ],
      },
    };
  },
  created() {
    this.fetchData();
    this.selects.simple = this.value;
  },
  methods: {
    fetchData() {
      return this.$http
        .get(`${process.env.VUE_APP_ANNUAIRE_API_URL}/titleEntities`)
        .then(response => {
          this.selects.titles = response.data._embedded.titleEntities.map(
            entity => ({
              value: entity.id,
              label: entity.name,
            }),
          );
        });
    },
  },
};
</script>

<style>
.form-group2 {
  margin-bottom: 10px;
}
.selectrow {
  padding-top: 5px;
}
.el-select .el-input.is-disabled .el-input__inner {
  cursor: not-allowed;
  color: #66615b;
  background-color: lightgray;
  border: #66615b;
}
</style>
